import React, { Component } from 'react';
import ProductDetailDesktop from './ProductDetailDesktop';
import ProductDetailMobile from './ProductDetailMobile';
import { get, post } from './../../utility/apiClient';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox } from '../../redux/actions/messageBoxActions';
import { showLoadingScreen, hideLoadingScreen } from '../../redux/actions/loadingScreenActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        responsive: state.responsive,
    }
};

const mapDispatchToProps = {
    showLoadingScreen,
    hideLoadingScreen,
    showMessageBox
};

class ProductDetailDefault extends Component {

    render() {
        return (
            <React.Fragment>
                {
                    this.props.responsive.isTabScreen
                        || this.props.responsive.isMobileLargeScreen
                        || this.props.responsive.isMobileSmallScreen
                        ?
                        this.props.ProductDetail ? <ProductDetailMobile product={this.props.ProductDetail} /> : <ProductDetailMobile product={this.props} />
                        : this.props.ProductDetail ? <ProductDetailDesktop product={this.props.ProductDetail} /> : <ProductDetailDesktop product={this.props} />
                }
            </React.Fragment>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailDefault);
